import { useEffect, useState, useContext } from 'react';
import { FirebaseContext } from './Firebase';

function ViolaterImage({ imagePath }) {
  const [url, setUrl] = useState("")

  const firebase = useContext(FirebaseContext)

  useEffect(() => {
    const storage = firebase.storage;

    storage .ref( `/${imagePath}` )
      .getDownloadURL()
      .then( url => {
        setUrl(url)
        console.log(url)
      })
      .catch(_ => {
        setUrl("")
        console.log(_)
      });

  }, [imagePath])

  return url !== "" ? (<img src={url}/>) : <div />;
  
}

export default ViolaterImage;
